import script from "./updateInformationValidationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./updateInformationValidationPage.vue?vue&type=script&setup=true&lang=js"

import "./updateInformationValidationPage.vue?vue&type=style&index=0&id=76f28ab7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f28ab7"]])

export default __exports__